import { connect } from '../../../common/components/runtime-context';
import SearchResultsList from '../../components/search-results-list';

const mapRuntimeToProps = (_state, _ownProps, actions) => ({
  onPostLikeClick: actions.incrementPostLikeCount,
  onCommentLikeClick: actions.incrementCommentLikeCount,
});

export default connect(mapRuntimeToProps)(SearchResultsList);
